module.exports = __webpack_public_path__ + "media/images/flags/64/Hong-Kong-1dcaba1e5d5f60a92f8893cf2aa9abdf.png";